﻿(function (angular, window) {
  "use strict";

  angular.module("Toyota").directive("tyRichtextAddNewVehicleToWishlist", [
    "$rootScope",
    "Wishlist",
    "DebugLogger",
    function ($rootScope, Wishlist, DebugLogger) {
      return {
        scope: true,
        restrict: "A",
        link: function (scope, element, attrs) {
          $rootScope.$on(
            "pricing-page-material-code-paint-loaded",
            function (e, materialCode) {
              DebugLogger.log(
                "tyRichtextAddNewVehicleToWishlist",
                "pricing-page-material-code-paint-loaded:",
                materialCode
              );
              scope.pricingPageMaterialCode = materialCode;
            }
          );

          Wishlist.onAddNewVehicleToWishlistSuccess((e) => {
            DebugLogger.log(
              "tyRichtextAddNewVehicleToWishlist",
              "onAddNewVehicleToWishlistSuccess handler fired with event data:",
              e
            );
          });

          element.on("click", function (e) {
            Wishlist.addNewVehicleToWishlist(scope.pricingPageMaterialCode, "ty-richtext-add-new-vehicle-to-wishlist");
            e.preventDefault();
          });
        },
      };
    },
  ]);
})(window.angular, window);
